import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';

import Button from '../../../components/UI/Button/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './Success.css';
import Box from '../../../hoc/Box/Box';
import axios from '../../../axios-local-api';
import Input from '../../../components/UI/Input/Input';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
import * as actions from '../../../store/actions/index';
import {
  updateObject,
  checkValidity
} from '../../../shared/utility';
import { FaCheckCircle } from 'react-icons/fa';

class Success extends Component {
  state = {    
    formIsValid: false
  }

  render() {
    return (
      <div className={classes.Success}>
        <div>
          <div id={this.props.id ? this.props.id : 'SuccessMsg'} className={classes.HeaderRow} style={{ justifyContent: this.props.showIcon ? 'left' : 'center'}}>
            {this.props.showIcon && <FaCheckCircle style={{ color: 'green', marginTop: 24, marginRight: 10, }} /> }
          <h4 style={{ color: 'green' }}>{this.props?.message || 'Success!'}</h4>
        </div>
        {this.props.subHeading && <div>{this.props.subHeading}</div>}
          </div>
        </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  }
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Success, axios));
